export const siteNav = [
  { id: "overview", label: "影片概览" },
  { id: "plot", label: "剧情与看点" },
  { id: "cast", label: "人物群像" },
  { id: "quality", label: "画质版本" },
  { id: "lines", label: "播放线路" },
  { id: "download", label: "下载收藏" },
  { id: "timeline", label: "剧情节奏" },
  { id: "faq", label: "常见问题" },
];

export const heroStats = [
  { value: "4 档", label: "可选画质" },
  { value: "3 条", label: "播放线路" },
  { value: "完整版", label: "无删减剧情" },
  { value: "全端", label: "手机·电脑" },
];

export const overviewFacts = [
  { key: "片名", value: "嫂子的诱惑（无删减完整版）", icon: "ri-film-line" },
  { key: "题材类型", value: "都市情感 · 家庭伦理", icon: "ri-bookmark-3-line" },
  { key: "语言字幕", value: "原声对白 · 简体中文字幕", icon: "ri-file-text-line" },
  { key: "版本状态", value: "完整版 / 无删减", icon: "ri-fullscreen-line" },
  { key: "推荐画质", value: "1080P 及以上", icon: "ri-hd-line" },
  { key: "适合人群", value: "都市情感题材爱好者", icon: "ri-user-heart-line" },
];

export const overviewIntro = [
  "《嫂子的诱惑》属于都市情感与家庭伦理交叉的题材，剧情的推进主要依靠人物之间的关系张力、生活处境的变化以及一次次选择带来的连锁反应。无删减完整版保留了完整的情感铺垫与关键转折，让人物的动机更连贯，也让观众能更清楚地理解每一次冲突的来由。",
  "很多观众在搜索时关注的是「完整版」与「删减版」的差别。通常来说，完整版会保留更完整的场景过渡与细节对白，这些内容往往承担着情绪铺垫与人物塑造的作用；而删减版为了压缩时长，可能会牺牲部分前后呼应。本页把版本差异、画质选项、播放线路和收藏方式集中整理，帮助你在最短时间内定位真正需要的信息。",
  "需要说明的是，本页是信息整理与观影指引页面，不对剧情细节作绝对化的描述，也不提供任何侵权资源。你可以在下方各分区中按需浏览：先看概览了解基本设定，再看看点与人物，最后依照线路与画质说明选择适合自己的观看方式。",
];

export const plotHighlights = [
  {
    icon: "ri-emotion-line",
    title: "关系张力写实",
    desc: "故事把镜头对准同一屋檐下的日常相处，用生活化的细节堆积情绪，冲突不是靠夸张事件推动，而是由一次次没说出口的话慢慢发酵。",
  },
  {
    icon: "ri-timeline-view",
    title: "多线并行的叙事",
    desc: "主线之外还有若干支线并行展开，不同人物的处境彼此呼应。完整版保留了这些支线的过渡段落，让前后因果更清晰。",
  },
  {
    icon: "ri-discuss-line",
    title: "对白承载体量",
    desc: "大量关键信息藏在对白里，语气、停顿和未说完的句子都是情节的一部分。建议观看时保持连贯，避免跳看关键对话场景。",
  },
  {
    icon: "ri-contrast-drop-line",
    title: "情绪起伏分明",
    desc: "整体节奏由平缓逐步走向集中，中后段的转折相对密集。喜欢循序渐进体验人物变化的观众会更容易代入。",
  },
  {
    icon: "ri-home-smile-line",
    title: "生活质感场景",
    desc: "室内场景与日常环境占比高，色调偏暖，画面更贴近生活现场，而非强戏剧化的舞台感。",
  },
  {
    icon: "ri-search-eye-line",
    title: "细节暗线可观",
    desc: "不少物品、镜头角度和重复出现的场景都埋有暗示，二刷时回看前段会有新的理解，这也是完整版更值得收藏的原因之一。",
  },
];

export const characters = [
  {
    name: "嫂子",
    role: "核心人物",
    tag: "情感主线",
    desc: "故事视角围绕她的处境展开，在家庭责任与个人情感之间反复权衡，是推动全剧情绪走向的关键人物。",
    img: "https://readdy.ai/api/search-image?query=Elegant%20cinematic%20portrait%20of%20a%20graceful%20young%20woman%20in%20warm%20amber%20light%2C%20soft%20chiaroscuro%20shadows%2C%20deep%20crimson%20accent%2C%20film%20grain%20texture%2C%20moody%20theatrical%20atmosphere%2C%20refined%20and%20classy%2C%20blurred%20warm%20background&width=600&height=800&seq=char-lady-01&orientation=portrait",
  },
  {
    name: "小叔子",
    role: "关系变数",
    tag: "冲突来源",
    desc: "他的出现打破了原有家庭关系里微妙的平衡，年轻气盛与沉默寡言交织，是剧情里最直接的关系变量。",
    img: "https://readdy.ai/api/search-image?query=Cinematic%20portrait%20of%20a%20pensive%20young%20man%20in%20dim%20warm%20interior%20lighting%2C%20deep%20shadows%20across%20the%20face%2C%20muted%20terracotta%20tones%2C%20soft%20film%20grain%2C%20contemplative%20mood%2C%20blurred%20amber%20background&width=600&height=800&seq=char-man-01&orientation=portrait",
  },
  {
    name: "兄长",
    role: "家庭支点",
    tag: "现实压力",
    desc: "作为家庭结构中的稳定角色，他的沉默与忙碌构成故事的现实底色，也是许多矛盾长期被压抑的原因。",
    img: "https://readdy.ai/api/search-image?query=Cinematic%20portrait%20of%20a%20weathered%20middle%20aged%20man%20with%20tired%20eyes%20in%20soft%20warm%20window%20light%2C%20earthy%20brown%20and%20gold%20tones%2C%20gentle%20film%20grain%2C%20reflective%20somber%20mood%2C%20blurred%20home%20interior%20background&width=600&height=800&seq=char-brother-01&orientation=portrait",
  },
  {
    name: "好友",
    role: "旁观视角",
    tag: "情绪出口",
    desc: "她承担着倾听与发问的功能，很多观众心里的疑问会通过她的追问被说出，也让主角的内心有了出口。",
    img: "https://readdy.ai/api/search-image?query=Cinematic%20portrait%20of%20a%20warm%20friendly%20young%20woman%20smiling%20softly%20in%20golden%20afternoon%20light%2C%20warm%20honey%20and%20cream%20tones%2C%20delicate%20film%20grain%2C%20gentle%20hopeful%20mood%2C%20blurred%20sunlit%20cafe%20background&width=600&height=800&seq=char-friend-01&orientation=portrait",
  },
];

export const qualityTiers = [
  {
    name: "标清 SD",
    resolution: "480P",
    desc: "体积小、加载快，适合网络环境一般的移动流量观看。细节与暗部层次会有明显压缩。",
    badge: "省流量",
    level: 1,
  },
  {
    name: "高清 HD",
    resolution: "720P",
    desc: "清晰度与体积比较均衡，手机与普通笔记本观看的常用档位，人物面部细节基本可辨。",
    badge: "均衡",
    level: 2,
  },
  {
    name: "超清 FHD",
    resolution: "1080P",
    desc: "推荐的默认画质，室内场景的层次、暖色调过渡和字幕锐度都更完整，适合大多数设备。",
    badge: "推荐",
    level: 3,
  },
  {
    name: "蓝光 UHD",
    resolution: "2160P",
    desc: "面向大屏与收藏需求，画面细节和暗部最完整，但对带宽、存储与设备解码能力要求较高。",
    badge: "收藏级",
    level: 4,
  },
];

export const streamingLines = [
  {
    id: "line-1",
    name: "线路一 · 主线畅通",
    tag: "首选",
    feature: "专用主线路，高峰期仍保持较稳定的加载速度",
    suited: "适合追求连续观看、不频繁拖动进度的观众",
    points: [
      "首屏缓冲时间较短，点开即可进入正片",
      "支持自动记忆上次播放进度",
      "中后段密集转折段落极少出现卡顿",
    ],
    status: "流畅",
  },
  {
    id: "line-2",
    name: "线路二 · 备用分流",
    tag: "备选",
    feature: "独立分流节点，当主线路拥堵时自动分担访问压力",
    suited: "适合在网络高峰时段观看、或主线路加载缓慢的情况",
    points: [
      "与主线内容完全一致，仅传输节点不同",
      "在晚间高峰时段往往更顺畅",
      "切换线路后需重新定位到对应进度",
    ],
    status: "稳定",
  },
  {
    id: "line-3",
    name: "线路三 · 移动优化",
    tag: "手机",
    feature: "针对移动网络优化传输，弱网环境下可自动降档",
    suited: "适合用手机数据流量、通勤路上碎片化观看",
    points: [
      "弱网下优先保证播放连续性",
      "可按网络状况在标清与高清间自动切换",
      "长时间观看流量消耗相对可控",
    ],
    status: "省流",
  },
];

export const downloadSteps = [
  {
    step: "01",
    title: "先确认版本",
    desc: "在下载前先核对是否为「无删减完整版」，避免下到缺段版本。可对照本页的版本说明确认时长与内容完整性。",
  },
  {
    step: "02",
    title: "选择合适画质",
    desc: "根据设备屏幕与存储空间选择画质。手机日常观看推荐 720P 或 1080P；收藏与投屏建议选择更高档位。",
  },
  {
    step: "03",
    title: "检查字幕与音轨",
    desc: "确认字幕为简体中文、音轨为原声对白。若播放器未自动加载字幕，可在播放设置中手动指定字幕文件。",
  },
  {
    step: "04",
    title: "规范命名与归档",
    desc: "下载后建议统一命名并归档到独立文件夹，便于后续查找与多设备同步，也能避免与其它资源混淆。",
  },
  {
    step: "05",
    title: "本地播放设置",
    desc: "使用支持多格式的播放器，按需开启硬件解码以获得更流畅的播放体验。大屏设备建议保持原始分辨率播放。",
  },
];

export const plotTimeline = [
  {
    phase: "第一阶段 · 铺垫",
    title: "日常关系的建立",
    desc: "前段着重交代家庭结构与人物处境，节奏相对平缓，是理解后续选择动机的必要铺垫，建议完整观看。",
  },
  {
    phase: "第二阶段 · 变化",
    title: "平衡被打破",
    desc: "随着新关系与新事件的加入，原有相处模式出现松动，人物之间的试探与回避开始增多。",
  },
  {
    phase: "第三阶段 · 集中",
    title: "矛盾浮出水面",
    desc: "此前埋下的暗示在此阶段集中显现，多条线索交汇，情绪张力达到相对密集的区间。",
  },
  {
    phase: "第四阶段 · 收束",
    title: "选择与结果",
    desc: "人物做出各自的决定，故事回到生活本身。完整版保留了收束段的细节，让结局更完整。",
  },
];

export const faqs = [
  {
    q: "无删减完整版和普通版有什么不同？",
    a: "一般来说，完整版会保留更完整的场景过渡与关键对白，这些内容承担着情绪铺垫和人物动机的说明作用；压缩版本为了控制时长，往往会把部分铺垫段落剪短，导致前后因果不够连贯。追求完整体验建议选择完整版。",
  },
  {
    q: "应该选择哪一档画质观看？",
    a: "日常用手机或普通笔记本观看，1080P 的清晰度与体积最均衡，是推荐档位。网络条件一般时可选 720P；有投屏或收藏需求，再考虑更高档位，但需要更充足的带宽与存储空间。",
  },
  {
    q: "三条播放线路有什么区别？",
    a: "三条线路的正片内容完全一致，区别在于传输节点与优化方向：线路一为主线路，线路二为备用分流，线路三针对移动网络做了优化。若某条线路加载缓慢，切换到其它线路通常可以改善。",
  },
  {
    q: "观看时卡顿、加载慢怎么处理？",
    a: "可以先尝试切换播放线路，再检查当前网络是否被其它应用占用。若使用移动数据，可适当降低画质档位以保证播放连续性。高峰时段（晚间）出现短暂缓冲属于常见情况。",
  },
  {
    q: "剧情需要一口气看完吗？",
    a: "本剧依靠前段的铺垫建立人物关系，建议尽量避免在中段频繁跳看，否则容易漏掉关键对白与暗示。若时间紧张，可分段观看，但推荐按顺序推进。",
  },
  {
    q: "本站会提供下载链接吗？",
    a: "本页是信息整理与观影指引页面，不提供也不托管任何影视资源文件，文中涉及的「下载指引」仅指观看与收藏过程中需要注意的通用事项。请通过正规授权渠道观看并支持正版。",
  },
];

export const relatedGenres = [
  {
    category: "情感",
    title: "都市情感剧",
    desc: "以现代都市生活为背景，聚焦人物在情感与现实之间的取舍，节奏偏细腻写实。",
    tags: ["写实", "细腻"],
  },
  {
    category: "伦理",
    title: "家庭伦理剧",
    desc: "围绕家庭内部关系展开，用日常细节呈现亲情、责任与代际差异带来的张力。",
    tags: ["家庭", "关系"],
  },
  {
    category: "悬疑",
    title: "情感悬疑剧",
    desc: "在情感叙事中埋入层层线索，随着剧情推进逐步揭开隐藏的关系与真相。",
    tags: ["反转", "线索"],
  },
  {
    category: "情感",
    title: "治愈生活向",
    desc: "节奏舒缓，强调生活质感与情绪修复，适合放松时观看，氛围温暖轻松。",
    tags: ["温暖", "轻松"],
  },
  {
    category: "悬疑",
    title: "都市罪案剧",
    desc: "以案件侦破为主线，同时刻画人性与关系，情节推进紧凑、信息密度高。",
    tags: ["紧凑", "烧脑"],
  },
  {
    category: "伦理",
    title: "现实题材群像",
    desc: "多条人物线并行，展现不同处境下的选择，整体贴近社会现实，代入感强。",
    tags: ["群像", "现实"],
  },
];

export const genreFilters = ["全部", "情感", "伦理", "悬疑"];